export default __webpack_public_path__ + "static/media/noa-43.46a78596.jpg";